/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartItemAddOnAddResponseFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartItemAddOnAddRequest, serializeWebhusetOrderApiFeaturesCartItemAddOnAddResponse, type WebhusetOrderApiFeaturesCartItemAddOnAddRequest, type WebhusetOrderApiFeaturesCartItemAddOnAddResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/item/{cartItemId}/addon
 */
export interface AddonRequestBuilder extends BaseRequestBuilder<AddonRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartItemAddOnAddResponse>}
     */
     post(body: WebhusetOrderApiFeaturesCartItemAddOnAddRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartItemAddOnAddResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: WebhusetOrderApiFeaturesCartItemAddOnAddRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AddonRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/item/{cartItemId}/addon";
/**
 * Metadata for all the requests in the request builder.
 */
export const AddonRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: AddonRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartItemAddOnAddResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartItemAddOnAddRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
